import { watch } from 'vue'
import { useUserStore } from '@/stores/user'
import { useCreationStore } from '@/stores/task'
import { useWorksStore } from '@/stores/works'
import { useLikeStore } from '@/stores/like'
import { useCollectStore } from '@/stores/collect'
import { useHistoryStore } from '@/stores/history'
import { connectSignalService, disconnectSignalService } from '@/websocket/runtime'

/**
 * 应用启动编排 composable
 * 职责：监听认证状态变化，统一管理 SignalR 连接、realtimeSync 启停、登出清理
 * 调用时机：App.vue 的 <script setup> 中，仅执行一次
 */
export function useAppBootstrap() {
  const userStore = useUserStore()
  const creationStore = useCreationStore()
  const worksStore = useWorksStore()
  const likeStore = useLikeStore()
  const collectStore = useCollectStore()
  const historyStore = useHistoryStore()

  // 监听 token 变化，管理 SignalR 连接和 realtimeSync
  watch(
    () => userStore.token,
    (newToken) => {
      if (!newToken) {
        creationStore.setTaskStatusPushHandler(null)
        creationStore.stopRealtimeSync()
        worksStore.stopRealtimeSync()
        disconnectSignalService()
        return
      }

      creationStore.setTaskStatusPushHandler(() => userStore.refreshProfileInfo())
      connectSignalService(newToken)
      creationStore.startRealtimeSync()
      worksStore.startRealtimeSync()
    },
    { immediate: true },
  )

  // 监听登出事件（authVersion 变化且未登录），统一清理各 store
  watch(
    () => userStore.authVersion,
    () => {
      if (userStore.isLogin) return

      likeStore.clear()
      collectStore.clear()
      historyStore.clear()
      creationStore.clear()
      worksStore.clear()
    },
  )
}
